/**
 * 位置情報を取得する関数
 * @returns 取得した位置情報のPromiseオブジェクト
 */
export const getLocation = async () => {
  if (!("geolocation" in navigator)) {
    throw new Error("お使いのブラウザでは位置情報が取得できません。")
  }
  try {
    const position = await new Promise<GeolocationPosition>((resolve, reject) =>
      navigator.geolocation.getCurrentPosition(resolve, reject),
    )
    const { latitude, longitude } = position.coords
    return { latitude, longitude }
  } catch (error) {
    console.error(error)
    throw new Error("位置情報が取得できませんでした。位置情報の設定や電波状況をご確認ください。")
  }
}
